/** @format */

const initialState = {
  claimed: null,
  id: null,
  name: '',
  email: '',
  role: '',
  token: '',
  created_at: null,
  updated_at: null,
};

export const generalAuthReducer = (
  state = {
    auth: initialState,
    currency: null,
  },
  action
) => {
  switch (action.type) {
    case 'AUTH_GET':
      return state;
    case 'AUTH_SET':
      return {
        ...state,
        auth: action.auth,
      };
    case 'CURRENCY_SET':
      return {
        ...state,
        currency: action.currency,
      };
    case 'AUTH_RESET':
      return initialState;
    default:
      return state;
  }
};
